import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import { connect, Provider } from 'react-redux';
import { merge, get, clone, set, findIndex } from 'lodash';
import moment from 'moment';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Modal, Icon, InputItem } from 'antd-mobile';
import { Loading } from '../../../components/loading';
import { ShareTip } from '../../../components/copyright/shareTip';
import { DetailShare } from '../../../components/copyright/detailShare';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { getNewsDetail, updateReadNum, setNewsPraise, setCancelNewsPraise } from './action';
import { getUploadToken } from '../upload/action';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { base64ToBlob, blobToFile, readCookie, calcDate, createCookie } from '../../../utils/common';
import LazyLoad from 'vanilla-lazyload';
import { Vh5Video } from '../../../components/videoPaler';
import { _track } from '../../../utils/track';
import './index.scss';
import emptyImg from '../../../img/empty.svg';
import newsFileImg from '../../../img/news-file.svg';
const mapStateToProps = state => {
	return {
		newsDetail: state.CopyrightNewsReducers.newsDetail,
	};
};
let lazyLoadInstance = null;
function CopyrightNewsDetail(props) {
	let praiseState = true;
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { newsDetail = {} } = useMappedState(mapState);
	let [effectFlag, setEffectFlag] = useState(1);
	let [isShowShareTip, setIsShowShareTip] = useState(false);
	const [cache, setCache] = useState(() => {
		return get(props, 'location.state.cache', false);
	});
	let params = useParams();
	let { id } = params;
	let dispatch = useDispatch();
	function toActivity(item) {
		//处理微信授权的问题 通过history.push 方式会导致打开activity分享空白
		_track({
			trackName: 'toutu_news_page',
			payload: {
				id: item.id,
				page_action_name: 'news-location-newdetail'
			}
		});
		window.location.href = '/vpmobile/copyright/newsDetail/' + item.id;
	}
	function onPraise() {
		if (!praiseState) {
			return;
		}
		praiseState = false;
		dispatch(
			getUploadToken(null, data => {
				if (data.code !== 0) {
					createCookie('userToken', '', 180);
					Modal.alert('提示', '登录过期，是否去登录？', [
						{ text: '再看看', onPress: () => {} },
						{
							text: '去登录',
							onPress: () => {
								window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent(window.location.pathname);
							}
						}
					]);
					return;
				}
				let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
				dispatch(
					setNewsPraise(
						{
							userId: userId,
							projectionNewsId: id
						},
						data => {
							praiseState = true;
						},
						data => {
							praiseState = true;
						}
					)
				);
			})
		);
	}
	function onCancelPraise() {
		let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
		if (true) {
			dispatch(
				setCancelNewsPraise(
					{
						userId: userId,
						projectionNewsId: id
					},
					data => {},
					data => {}
				)
			);
		}
	}
	function handleClickShareBtn() {
		setIsShowShareTip(true);
	}
	function handleClickShareTip() {
		setIsShowShareTip(false);
	}
	useEffect(() => {
		console.log(cache, effectFlag, newsDetail);
		let userId = readCookie('copyrightuserId') || 0;
		if (!cache || (effectFlag === 1 && !newsDetail)) {
			setCache(true);
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 300
				// ... more custom settings?
			});
			dispatch(
				getNewsDetail({ id: id, userId: userId }, data => {
					console.log('newsDetail', newsDetail);
					lazyLoadInstance.update();
					_track({
						trackName: 'toutu_news_page',
						payload: {
							newsId: data.id,
							page_action_name: 'news-init-newsdetail'
						}
					});
				})
			);
			dispatch(
				updateReadNum({ projectionNewsId: id, userId: userId }, data => {
					_track({
						trackName: 'toutu_news_page',
						payload: {
							page_action_name: 'news-init-newsdetail'
						}
					});
				})
			);
			dispatch(
				getWeixinConfig({ url: window.location.href }, data => {
					console.log('getWeixinConfig', data);
					configWeixin(data, {
						title: '投图',
						desc: '主题影像即时创作平台'
					});
					_track({
						trackName: 'toutu_news_page',
						payload: {
							page_action_name: 'news-init-wxconfig'
						}
					});
				})
			);
		} else if (effectFlag === 1 && cache) {
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 0
				// ... more custom settings?
			});
		}
	}, [dispatch, effectFlag, props, cache, newsDetail, id]);
	return (
		<div className="copyright copyright-newsDetail">
			<header className="nav-header-container">
				<div className="back">
					<span className="icon"></span>
					<label
						onClick={() => {
							history.go(-1);
						}}>
						返回
					</label>
				</div>
				<span className="title">投图资讯</span>
			</header>
			{newsDetail ? (
				<div>
					<div className="newsDetail-container">
						<div className="news-title">{newsDetail.title}</div>
						<div className="news-tips">{newsDetail.crUserName} · {calcDate(newsDetail.releaseTime)}</div>
						<div className="news-content" dangerouslySetInnerHTML={{__html: newsDetail.content}}></div>
						<div className="news-readNum">{newsDetail.customReadNum ? newsDetail.customReadNum : newsDetail.readNum}次阅读</div>
						{get(newsDetail, 'recommendNewsResps.length', 0) ? (
							<div className="news-history">
								<div style={{fontSize: '14px',color: '#333333', fontWeight: 'bold'}}>往期推荐</div>
								<div className="news-history-list">
									{newsDetail.recommendNewsResps.map((item, index)=>{
										return (
											<div key={'newsDetail-' + index} className="news-history-item" onClick={()=>{toActivity(item)}}>
												<img className="item-img" src={newsFileImg} />
												<div className="item-title">
													<div className="item-title-text">{item.title}</div>
												</div>
											</div>
										)
									})}
								</div>
							</div>
						) : (
							''
						)}
					</div>
					<div className="btn-container">
						{newsDetail.isPraise === 1 ? (
							<div className="btn-item" onClick={() => {onCancelPraise()}}>
								<span className='praise yes'>
									<i>&#xe668;</i>
									{newsDetail.customPraiseNum ? newsDetail.customPraiseNum : newsDetail.praiseNum}
								</span>
							</div>
						) : (
							<div className="btn-item" onClick={() => {onPraise()}}>
								<span className='praise no'>
									<i>&#xe668;</i>
									{newsDetail.customPraiseNum ? newsDetail.customPraiseNum : newsDetail.praiseNum}
								</span>
							</div>
						)}
						<div className="btn-item" onClick={() => {handleClickShareBtn()}}>
							<span className="share">
								<i>&#xe657;</i>
							</span>
						</div>
					</div>
					{isShowShareTip ? <ShareTip path='/vpmobile/copyright/newsDetail/' id={id} onClick={handleClickShareTip} /> : ''}
				</div>
			) : (
				<div className="no-data">
					<div>
						<img src={emptyImg} className="App-empty" alt="empty" />
					</div>
					<div>网络异常,请刷新重试</div>
				</div>
			)}
			
		</div>
	);
}
export { CopyrightNewsDetail };
